
async function streamToString(stream) {
  const reader = stream.getReader();
  const textDecoder = new TextDecoder();
  let result = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    result += textDecoder.decode(value);
  }
  return result;
}

const URL_BASE = 'https://hentaipress.com';

async function streamToJson(stream) {
  return JSON.parse(await streamToString(stream));
}

const apiLogin = async function(username, password) {
  const url = `${URL_BASE}/api/login`;
  try {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ username, password }),
        credentials: "include",
    });
    return {status: response.status, body: await streamToString(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

// Right now, this just gives back the first 10 books
const apiSuggestions = async function() {
  const url = `${URL_BASE}/api/suggestions`;
  try {
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });
    return {status: response.status, body: await streamToJson(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiOneBook = async function(bookId) {
  const url = `${URL_BASE}/api/books?book_id=${bookId}`;
  try {
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });
    return {status: response.status, body: await streamToJson(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiUser = async function() {
  const url = `${URL_BASE}/api/user`;
  try {
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });
    return {status: response.status, body: await streamToJson(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiForgotPassword = async function(email) {
  const url = `${URL_BASE}/api/forgot`;
  try {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ email }),
    });
    return {status: response.status, body: await streamToString(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiSignup = async function(username, password, confirm_password) {
  const url = `${URL_BASE}/api/signup`;
  try {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          username,
          password,
          confirm_password,
        }),
    });
    return {status: response.status, body: await streamToString(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiTags = async function(id, name, q, page, pageSize) {
  const url = `${URL_BASE}/api/tags?`;
  const params = [];
  if (id) {
    params.push(`id=${id}`)
  }
  if (name) {
    params.push(`name=${name}`)
  }
  if (q) {
    params.push(`q=${q}`)
  }
  if (page) {
    params.push(`page_num=${page}`)
  }
  if (pageSize) {
    params.push(`page_size=${pageSize}`)
  }
  try {
    const response = await fetch(url + params.join('&'), {
        method: "GET",
        credentials: "include",
    });
    return {status: response.status, body: await streamToJson(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const apiSearch = async function({q, author, pub, upl, tags}) {
  const url = `${URL_BASE}/api/search?`;
  const params = [];
  if (q) {
    params.push(`q=${q}`)
  }
  if (author) {
    params.push(`author=${author}`)
  }
  if (pub) {
    params.push(`pub=${pub}`)
  }
  if (upl) {
    params.push(`upl=${upl}`)
  }
  if (tags) {
    params.push(`tags=${tags}`)
  }
  try {
    const response = await fetch(url + params.join('&'), {
        method: "GET",
        credentials: "include",
    });
    return {status: response.status, body: await streamToJson(response.body)};
  } catch (error) {
    console.error(error.message);
  }
}

const adminUploadNewBook = async function(file) {
    if (file) {
      console.log('Uploading file...');

      const formData = new FormData();
      formData.append('file', file);

      try {
        // You can write the URL of your server or any other endpoint used for file upload
        const result = await fetch(`${URL_BASE}/api/upload`, {
          method: 'POST',
          body: formData,
          credentials: "include",
        });
        return 'Success';
      } catch (error) {
        console.error(error);
      }
    }
};

const adminCreateTag = async function(name, desc) {
  const url = `${URL_BASE}/api/tags`;
  try {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          name: name,
          description: desc,
        }),
        credentials: "include",
    });
    return {status: response.status, body: await streamToString(response.body)};
  } catch (error) {
    console.error(error.message);
  }  
}

const adminAssociateTags = async function(tagNames, bookId) {
  const url = `${URL_BASE}/api/associate`;
  try {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          tag_names: tagNames,
          book_id: bookId,
        }),
        credentials: "include",
    });
    return {status: response.status, body: await streamToString(response.body)};
  } catch (error) {
    console.error(error.message);
  } 
}

export {
  apiLogin,
  apiSuggestions,
  apiOneBook,
  apiForgotPassword,
  apiSignup,
  apiUser,
  apiTags,
  apiSearch,
  adminUploadNewBook,
  adminCreateTag,
  adminAssociateTags,
  URL_BASE,
};